import {fareRates} from '../config/fare-rates-enum';
import {outOfPolicyStatus} from '../../common/enum/out-of-policy-status-enum';
import {outOfPolicyStatusStyle} from '../../common/enum/out-of-policy-status-style';

export default function CarsListController(
    $scope,
    $rootScope,
    $stateParams,
    carsFactory,
    basketService,
    userService,
    l10nService,
    carService,
    searchData,
    $timeout,
) {
    'ngInject';
    const CARS_PER_PAGE = 20;

    let resultsLimit;
    let resultsOffset;
    let filters;

    const vm = this;
    const defaultSorting = {
        distance: {text: l10nService.localize('Distance'), value: -1, sortType: 0},
        price: {text: l10nService.localize('Price'), value: -1, sortType: 0},
    };

    Object.assign(vm, {
        $onInit,
        onSortTypeChange,
    });

    function $onInit() {
        initLimitAndOffset();
        initializeSortFields();
        setSorting();
        subscribe();
    }

    function subscribe() {
        $scope.$on('applyFilters', applyFilters);
    }

    function onSortTypeChange(value) {
        if (filters) {
            const data = Object.assign(filters, {CarSorting: value});
            applyFilters(false, data);
            return;
        }

        const data = Object.assign($stateParams, {CarSorting: value});
        carsFactory.setSortingFilterValue({CarSorting: value});
        carsFactory.getSearchData(data)
            .then(({searchResults}) => $scope.carsResults = searchResults);
    }

    function initializeSortFields() {
        vm.sortByPrice = [
            {text: 'price: low to high', value: 0},
            {text: 'price: high to low', value: 1},
            {text: 'distance: nearest', value: 2},
            {text: 'distance: furthest', value: 3},
        ];
        vm.defaultSort = {text: 'price: low to high', value: 0};
    }

    function initLimitAndOffset() {
        resultsLimit = CARS_PER_PAGE;
        resultsOffset = 0;
    }

    function applyFilters(event, newFilters) {
        if (newFilters) {
            filters = newFilters;
        }
        carsFactory.applyFilters(newFilters);
        carsFactory.getSearchData($stateParams)
            .then((resp) => {
                $scope.carsResults = resp.searchResults;
                initLimitAndOffset();
            });
    }
    $scope.$watch('$viewContentLoaded', function() {
             $timeout(function() {
            const widestSpan = _.max($('span.basket'), (item) => $(item).width());
            $('button.cars-add-to-basket').width($(widestSpan).width());
            }, 0);
    });

    $scope.composeCompanyLogoUrl = carService.getCarSupplierLogo;
    $scope.getCarImageUrl = carService.getCarImageUrl;

    $scope.carsResults = searchData.searchResults;
    $scope.userCulture = userService.getCulture();
    $scope.isLoadMoreVisible = () => {
        const {cars, filteredTotal} = $scope.carsResults;
        return cars && cars.length < filteredTotal;
    };

    $scope.addToBasket = basketService.addCar;

    $scope.isNoResultsLabelVisible = function() {
        return $scope.carsResults.filteredTotal === 0;
    };

    $scope.inBasket = function(car) {
        return basketService.inBasket('car', car);
    };

    $scope.cantBeAddedToBasket = function(car, fare) {
        return $scope.inBasket(car)
            || fare.OutOfPolicyStatus === outOfPolicyStatus.OutOfPolicyBookingProhibited
            || !car.CanBeBooked;
    };

    $scope.bookAttrTitle = function(car) {
        const carsTimeAvailable = moment(car.PickupDate).isAfter(moment().endOf('day'));

        return (!carsTimeAvailable)
            ? l10nService.localize('Please contact Key Travel to book this option as it is close to '
                + 'the departure time')
            : '';
    };

    $scope.loadMore = function() {
        resultsLimit += CARS_PER_PAGE;
        resultsOffset += CARS_PER_PAGE;

        carsFactory.loadMore(resultsLimit, resultsOffset)
            .then(({cars, filteredTotal}) => {
                $scope.carsResults.cars = [...$scope.carsResults.cars, ...cars];
                $scope.carsResults.filteredTotal = filteredTotal;
            });
    };

    vm.getLabelForPriceType = (typeId) => {
       const found = fareRates.find((item) => item.id === typeId);
       return found && found.label;
    };

    $scope.outOfPolicyStatusStyle = function(status) {
      return outOfPolicyStatusStyle(status);
    };

    function setSorting() { // eslint-disable-line
        $scope.carData = {
            distanceSort: [
                {text: l10nService.localize('Distance: nearest'), value: '2', sortType: 3},
                {text: l10nService.localize('Distance: furthest'), value: '3', sortType: 4},
            ],
            distanceSortSelected: {text: l10nService.localize('Distance: nearest'), value: '2', sortType: 3},
            priceSort: [
                {text: l10nService.localize('Price: low-high'), value: '0', sortType: 1},
                {text: l10nService.localize('Price: high-low'), value: '1', sortType: 2},
            ],
            priceSortSelected: angular.copy(defaultSorting.price),
        };

        const selectedSort = +$stateParams.carSorting || 0;

        switch (selectedSort) {
            case 1:
            case 2:
                const distanceIndex = selectedSort === 1 ? 0 : 1;
                $scope.carData.distanceSortSelected = angular.copy($scope.carData.distanceSort[distanceIndex]);
                break;
            case 3:
            case 4:
                const priceIndex = selectedSort === 1 ? 0 : 1;
                $scope.carData.priceSortSelected = angular.copy($scope.carData.priceSort[priceIndex]);
                break;
        }

    }

    $scope.$watch('carData.distanceSortSelected.value', function(newValue, oldValue) {
        if ((newValue === oldValue) || (+newValue === -1)) {
            return false;
        }

        _.extend($scope.carData.priceSortSelected, defaultSorting.price);
        onSortTypeChange($scope.carData.distanceSortSelected.value);
    });

    $scope.$watch('carData.priceSortSelected.value', function(newValue, oldValue) {
        if ((newValue === oldValue) || (+newValue === -1)) {
            return false;
        }
        _.extend($scope.carData.distanceSortSelected, defaultSorting.distance);

        onSortTypeChange($scope.carData.priceSortSelected.value);
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/controllers/carsListCtrl.js